export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-stores-info-retail',
  storesTotalLabel: 'partnerbasicinfo-stores-total-retail',
  storesPSHWLabel: 'partnerbasicinfo-stores-pshw-retail',
  storesPRHWLabel: 'partnerbasicinfo-stores-prhw-retail',
}
